import React, { useState } from 'react'
import { Modal, message, Upload, Button } from 'antd'
import BasicForm from '../formV4'
import PolygonAvatar from '../../components/UI/polygonAvatar'
import { createExpert, editExpert, saveAvatar } from '../../api'
import IconCamera from '../../asserts/icon/icon-camera.svg'
import TipCamera from '../../asserts/images/camera-tip.svg'
import _ from 'lodash'
import styled from 'styled-components'
import { expertFormModels } from '../../models/expert.upsert.form'

const StyledModal = styled(Modal)`
  .title {
    font-size: 36px;
    font-weight: 600;
  }
  .upload-avatar {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
`

const ExpertFormModal = (props) => {
  const {
    initValue,
    onCancel,
    submitSync,
    facilities,
    onDelete,
    lockFacility = false,
    allowDelete = true
  } = props

  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState(null)
  const [imageUrl, setImageUrl] = useState('')

  const [formRef, setFormRef] = useState(null)

  const isAdd = _.get(initValue, 'id', 0) === 0

  const submit = async () => {
    setLoading(true)
    try {
      const params = await formRef.handleSubmit()
      let expert, syncType, successMsg
      if (isAdd) {
        expert = await createExpert(params)
        syncType = 'create'
        successMsg = 'Created a new expert'
      } else {
        expert = await editExpert(params, initValue.id)
        syncType = 'update'
        successMsg = 'Expert updated'
      }

      if (file) {
        const result = await saveAvatar(file, expert.id)
        const person = result.person || result.data.person
        expert = { ...person, services: person.services || expert.services }
      }

      setLoading(false)
      submitSync(expert, syncType)
      message.success(successMsg)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  const cancel = () => {
    formRef && formRef.resetFields()
    onCancel()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const customRequest = (request) => {
    const { file } = request
    getBase64(file, (imageUrl) => {
      setImageUrl(imageUrl)
      setFile(file)
    })
  }

  const avatar =
    imageUrl || (initValue && initValue.avatar && initValue.avatar.oss_url)
  const formModels = expertFormModels(facilities, lockFacility)

  return (
    <StyledModal
      open={true}
      onCancel={cancel}
      width={880}
      footer={
        <>
          {!isAdd && allowDelete && (
            <Button
              danger
              ghost
              onClick={() => onDelete(initValue)}
              style={{
                float: 'left'
              }}
            >
              DELETE EXPERT
            </Button>
          )}

          <Button type="primary" onClick={onCancel} ghost>
            CANCEL
          </Button>
          <Button onClick={submit} type="primary" loading={loading}>
            {isAdd ? 'CREATE' : 'UPDATE'}
          </Button>
        </>
      }
    >
      <h1 className="title">
        {' '}
        {isAdd ? 'Create a new expert' : 'Edit Expert'}
      </h1>
      <div className="upload-avatar">
        {avatar ? (
          <div>
            <PolygonAvatar
              innerId="edit_avatar_inner"
              width={100}
              image={avatar}
              hexId="edit_avatar_hex"
            />
            <Upload
              name="avatar"
              customRequest={customRequest}
              showUploadList={false}
              className="edit-avatar"
            >
              <img src={TipCamera} alt="tip" />
            </Upload>
          </div>
        ) : (
          <Upload
            name="avatar"
            customRequest={customRequest}
            showUploadList={false}
          >
            <PolygonAvatar
              icon={IconCamera}
              width={100}
              iconX={37}
              iconY={43}
              innerId="add_avatar"
            />
          </Upload>
        )}
      </div>
      <div style={{ marginBottom: '30px' }}>
        <BasicForm
          wrappedComponentRef={(inst) => setFormRef(inst)}
          initialValues={initValue}
          formData={formModels}
          // onChange={updateValueForm}
        />
      </div>
    </StyledModal>
  )
}

export default ExpertFormModal
